// src/pages/LandingPage.tsx
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { getCompanyInfo } from '../services/mockApi';
import { Button } from '../components/Button';
import { Container, FlexCenter } from '../styles/commonStyles';
import backgroundImage from '../assets/background.jpg';

const LandingWrapper = styled(FlexCenter)`
  background-image: url(${backgroundImage});
  background-size: cover;   // Ensure the image covers the entire section
  background-position: center;
  background-repeat: no-repeat;   // Prevent the image from repeating
  height: 100vh;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  text-align: center;
  position: relative;

  // Add a dark overlay to improve text readability
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.55); // Semi-transparent black overlay
    z-index: 2;
  }

  // Ensure content is above the overlay
  & > * {
    position: relative;
    z-index: 2;
  }

`;

const CompanyInfo = styled(Container)`
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  font-weight: ${({ theme }) => theme.typography.title.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ theme }) => theme.typography.title.fontSizeLarge};
  }
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.text};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ theme }) => theme.typography.body.fontSizeLarge};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  width: 100%;
  max-width: 300px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    max-width: 600px;
    justify-content:center;
  }
`;

const LoadingText = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSizeLarge};
  color: ${({ theme }) => theme.colors.muted};
`;

const LandingPage: React.FC = () => {
  const [companyInfo, setCompanyInfo] = useState<{ title: string; description: string } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const data = await getCompanyInfo();
        setCompanyInfo(data);
      } catch (error) {
        console.error('Failed to fetch company info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyInfo();
  }, []);

  if (loading) {
    return (
      <LandingWrapper>
        <LoadingText>Loading...</LoadingText>
      </LandingWrapper>
    );
  }

  return (
    <LandingWrapper>
      <CompanyInfo>
        <Title>{companyInfo?.title}</Title>
        <Description>{companyInfo?.description}</Description>
      </CompanyInfo>
      <ButtonContainer>
        <Button to="/signup">Sign Up</Button>
        <Button to="/login">Log In</Button>
      </ButtonContainer>
    </LandingWrapper>
  );
};

export default LandingPage;